import React from 'react';
import { useSessionStorageStatus } from '../../../../../providers/SessionStorageStatus/SessionStorageStatusProvider';
import { usePersonalInformation } from '../../../providers/PersonalInformationProvider';
import { Button } from '../../../../../importCL';


export default function Buttons() {

    const { status } = useSessionStorageStatus();
    const { setIsSubmit } = usePersonalInformation();

    return (
        <Button
            onMouseDown={(e: React.MouseEvent<HTMLButtonElement>) => e.preventDefault()}
            onMouseUp={(e: any) => { 
                setIsSubmit(true);
                e.target.focus(); 
            }}
            id='BasicSubmitForm'
            className='max-w-fit mb-6'
            type='submit'
            disabled={!navigator.cookieEnabled || status === 'unusable'}
        >
            See Card Offers
        </Button>
    );
}
